import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-10 sm:py-16 bg-[#0a1628] border-t border-gray-800 text-center" data-id="element-53">
      <div className="max-w-3xl mx-auto px-3 sm:px-6" data-id="element-54">
        <h2 className="text-xl sm:text-3xl md:text-4xl font-black text-white mb-3 sm:mb-4 uppercase tracking-tight" data-id="element-55">
          ¿LISTO/A PARA DEJAR DE IMPROVISAR?
        </h2>

        <p className="text-sm sm:text-lg md:text-xl text-gray-300 mb-4 sm:mb-6 font-medium" data-id="element-56">
          Sumate a docentes que ya tienen su año resuelto.
        </p>

        <a href="https://checkout.kitonline.shop/cart/47698138988782:1" className="inline-flex items-center justify-center bg-[#dc2626] hover:bg-red-700 text-white text-sm sm:text-lg md:text-xl font-bold py-3 sm:py-4 px-5 sm:px-8 rounded-full shadow-[0_0_25px_rgba(220,38,38,0.6)] transition-all transform hover:scale-105 animate-pulse" data-id="element-57">
          👉 QUIERO EMPEZAR AHORA
        </a>
      </div>
    </section>;
}